import { render, staticRenderFns } from "./PointAdjustmentList.vue?vue&type=template&id=74c74ab2&"
import script from "./PointAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./PointAdjustmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports